const messages = {
  title: 'Interne fout',
  description: 'De gegevens voor deze pagina kunnen niet correct worden geladen.',
  backHomeButton: 'Terug naar dashboard'
}

export default {
  messages
}